import Caption from 'primitives/Typography/BodyCopy/Caption';
import styled from '@emotion/styled';

const HeaderCaption = styled(Caption)(({ theme }) => ({
  color: theme.colors.gray['400'],
  marginBottom: '0.8rem',
}));

export default HeaderCaption;
